(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (factory((global.piDash = global.piDash || {})));
}(this, (function (exports) { 'use strict';

/*
 * Collection helpers. These helpers act on either objects or arrays.
 * */

/**
 * like [].forEach but works on objects as well. On objects will loop through all inherited members as well
 * @param object - source object or array
 * @param iteratee - function to be called on each iteration
 */
var forEach = function forEach(object, iteratee) {
    for (var item in object) {
        iteratee(object[item], item);
    }
};

/**
 * Iterates over own enumerable properties of an object invoking iteratee for each property. The iteratee is invoked with three arguments: (value, key, object). Iteratee functions may exit iteration early by explicitly returning false.
 * @param {Object} object - The object to iterate over
 * @param {Function} iteratee - The function invoked per iteration
 */
var forOwn = function forOwn(object, iteratee) {
    for (var item in object) {
        if (object.hasOwnProperty(item)) {
            iteratee(object[item], item);
        }
    }
};

/**
 * Iterates over elements of collection, returning an array of all elements predicate returns truthy for. The predicate is invoked with three arguments: (value, index|key, collection).
 * @param collection {Array|Object}: The collection to iterate over.
 * @param predicate {Function}: The function invoked per iteration.
 * @returns {Array}
 */
function filter(collection, predicate) {
    var results = [];
    forEach(collection, function (value, index, list) {
        if (predicate(value, index, list)) results.push(value);
    });
    return results;
}

/*
* Array helpers.
* */

/**
 * Creates an array with all falsey values removed. The values false, null, 0, "", undefined, and NaN are falsey.
 * @param array
 */
function compact(array) {
  return filter(array, Boolean);
}

/*
 * Helpers that modify how and when functions execute.
 * */

/**
 * Creates a function that is restricted to invoking func once. Repeat calls to the function return the value of the
 * first invocation. The func is invoked with the this binding and arguments of the created function.
 * @param fn (function) - the function to restrict
 * @returns {function(...[*]=)}
 */
var once = function once(fn) {
    var _this = this;

    var called = false;
    var rv = void 0;
    return function () {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        var context = _this;
        if (!called) {
            rv = fn.apply(context, args);
            called = true;
        }
        return rv;
    };
};

/**
 * Creates a throttled function that only invokes func at most once per every wait milliseconds. The func is invoked
 * with the arguments provided to the throttled function in the context from which it was invoked. func will only be
 * invoked on the leading edge of each wait timeout.
 * @param func {Function} - The function to throttle.
 * @param delay {Number} - The number of milliseconds to throttle invocations to. Defaults to 100 if unspecified.
 * @returns {Function} Returns the new throttled function.
 */
var throttle = function throttle(func) {
    var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;

    var wait = false;

    return function () {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
            args[_key2] = arguments[_key2];
        }

        var self = this;
        if (!wait) {
            wait = true;
            setTimeout(function () {
                wait = false;
                func.apply(self, args);
            }, delay);
        }
    };
};

/*
 * Object helpers.
 * */

/**
 * Assigns own and inherited enumerable string keyed properties of source objects to the destination object for all
 * destination properties that resolve to undefined. Source objects are applied from left to right. Once a property is
 * set, additional values of the same property are ignored.
 * NOTE: This will mutate the original object
 * @param object
 * @param [sources]
 */
function defaults(object) {
    for (var _len = arguments.length, sources = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        sources[_key - 1] = arguments[_key];
    }

    forEach(sources, function (source) {
        forEach(source, function (value, key) {
            if (!object.hasOwnProperty(key)) {
                object[key] = value;
            }
        });
    });
    return object;
}

/**
 * Gets the value at path of object. If the resolved value is undefined, the defaultValue is returned in its place.
 * @param object (Object): The object to query.
 * @param path (Array|string): The path of the property to get.
 * @param [defaultValue] (*): The value returned for undefined resolved values.
 */
function get(object, path) {
    var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

    var props = path.split('.');
    var out = object;
    while (out && props.length) {
        var next = props.shift();
        if (out[next]) {
            out = out[next];
        } else {
            var arrayMatches = next.match(/\[(\d)\]/);
            if (arrayMatches) {
                next = next.replace(arrayMatches[0], '');
                out = out[next] ? out[next][arrayMatches[1]] : defaultValue;
            } else {
                out = defaultValue;
                break;
            }
        }
    }
    return out;
}

/**
 * Assigns own enumerable properties of source objects to the destination object. Source objects are applied from left to right. Subsequent sources overwrite property assignments of previous sources.
 * @param {Object} object - The destination object
 * @param {Object} [sources] The source objects
 * @returns {Object} returns object
 */
var assign = function assign(object) {
    for (var _len2 = arguments.length, sources = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        sources[_key2 - 1] = arguments[_key2];
    }

    forEach(sources, function (arg) {
        forOwn(arg, function (prop, name) {
            object[name] = prop;
        });
    });
    return object;
};

/**
 * Creates a shallow clone of value.
 * @param value - the value to clone
 */
var clone = function clone(value) {
    return assign({}, value);
};

/**
 * Creates an object composed of the inverted keys and values of object. If object contains duplicate values, subsequent values overwrite property assignments of previous values.
 * @param object (Object): The object to invert.
 * @returns (Object): Returns the new inverted object.
 */
function invert(object) {
    var result = {};
    var keys = Object.keys(object);
    for (var i = 0, length = keys.length; i < length; i++) {
        result[object[keys[i]]] = keys[i];
    }
    return result;
}

/*
 * Helpers that make common string functions simpler.
 * */

var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    '\'': '&#x27;',
    '`': '&#x60;'
};
var unescapeMap = invert(escapeMap);

// Helper to create escape maps
var createEscaper = function createEscaper(map) {
    var escaper = function escaper(match) {
        return map[match];
    };

    // Regexes for identifying a key that needs to be escaped.
    var source = '(?:' + Object.keys(map).join('|') + ')';
    var testRegexp = new RegExp(source);
    var replaceRegexp = new RegExp(source, 'g');
    return function (string) {
        string = string == null ? '' : '' + string;
        return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
};

/**
 * Converts the characters "&", "<", ">", '"', "'", and "`" in string to their corresponding HTML entities.
 * @param [string=''] (string): The string to escape.
 */
var escape = createEscaper(escapeMap);

/**
 * The inverse of _.escape; this method converts the HTML entities &amp;, &lt;, &gt;, &quot;, &#39;, and &#96; in string
 * to their corresponding characters.
 * @param [string=''] (string): The string to unescape.
 */
var unescape = createEscaper(unescapeMap);

/**
 * Removes leading and trailing whitespace or specified characters from string.
 * @param (string): The string to trim.
 * @returns {XML|*|void|string}
 */
function trim() {
    var string = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

    return string.replace(/^\s+|\s+$/g, '');
}

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

/*
 * Helpers that help to determine type information.
 * */

var genTag = '[object GeneratorFunction]';
var funcTag = '[object Function]';
var objectToString = Object.prototype.toString;

/**
 * Checks if `value` is `undefined`.
 *
 * @static
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
 */
function isUndefined(value) {
  return value === undefined;
}

/**
 * Checks if value is the language type of Object. (e.g. arrays, functions, objects, regexes, new Number(0), and new String(''))
 * @param value - object to test
 * @returns {boolean}
 */
var isObject = function isObject(value) {
  // Avoid a V8 JIT bug in Chrome 19-20.
  // See https://code.google.com/p/v8/issues/detail?id=2291 for more details.
  var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
  return !!value && (type == 'object' || type == 'function');
};

/**
 * Checks if value is a function
 * @param value - object to test
 * @returns {boolean}
 */
var isFunction = function isFunction(value) {
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 8 which returns 'object' for typed array constructors, and
  // PhantomJS 1.9 which returns 'function' for `NodeList` instances.
  var tag = isObject(value) ? objectToString.call(value) : '';
  return tag == funcTag || tag == genTag;
};

exports.compact = compact;
exports.forEach = forEach;
exports.forOwn = forOwn;
exports.filter = filter;
exports.once = once;
exports.throttle = throttle;
exports.defaults = defaults;
exports.get = get;
exports.assign = assign;
exports.clone = clone;
exports.invert = invert;
exports.escape = escape;
exports.unescape = unescape;
exports.trim = trim;
exports.isUndefined = isUndefined;
exports.isObject = isObject;
exports.isFunction = isFunction;

Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=pi-dash.js.map
